/// <reference path="../pattern/Builder.ts" />

namespace SPA
{
	export namespace gui
	{
		/**
		 * Builder für Organisationsstrukturen.
		 *
		 * @extends SPA.pattern.Builder
		 */
		export abstract class OrganizationBuilder<T extends Wollmilch.RecipientObject>
			extends SPA.pattern.TabContentBuilder<T>
		{

			/**
			 *
			 * @param root Das root-Element, an dem die Oberfläche angehongen werden soll.
			 * @see SPA.pattern.builder.Builder#build
			 */
			public rebuild( root: JQuery|ui.base.BaseHTMLElement ): OrganizationBuilder<T>
			{
				return super.rebuild( root ) as OrganizationBuilder<T>;
			}

			protected constructor( object: T )
			{
				super( object );

				if  ( this.m_Data.ID === undefined )
				{
					throw new Error( 'ILLEGAL_RECIPIENT_OBJECT' );
				}
			}
		}
	}
}
